import { createContext, useContext } from "react";

const PatientModeContext = createContext({ patientMode: false, patientName: "" });

export const PatientModeProvider = PatientModeContext.Provider;
export const usePatientMode = () => useContext(PatientModeContext);
